// todo:不理解为什么需要web主动上报浏览器信息，这个信息应该是后端主动获取~

/**
 * system 系统类型
 * systemVs 系统版本
 * browser 浏览器类型
 * browserVs 浏览器版本
 * @returns {{system: string, browserVs: string, systemVs: string, browser: string}}
 */
const getBrowserInfo = () => {
  if (typeof navigator === 'undefined') return
  const ua = navigator.userAgent.toLowerCase()
  const testUa = (regexp: RegExp) => regexp.test(ua)
  const testVs = (regexp: RegExp) => {
    if (ua.match(regexp)) {
      return ua
        .match(regexp)
        ?.toString()
        .replace(/[^0-9|_.]/g, '')
        .replace(/_/g, '.')
    } else {
      return false
    }
  }

  // 系统
  let system = 'unknow'

  if (testUa(/windows|win32|win64|wow32|wow64/g)) {
    system = 'Windows' // windows系统
  } else if (testUa(/macintosh|macintel/g)) {
    system = 'macOS' // macos系统
  } else if (testUa(/x11/g)) {
    system = 'Linux' // linux系统
  } else if (testUa(/android|adr/g)) {
    system = 'Android' // android系统
  } else if (testUa(/ios|iphone|ipad|ipod|iwatch/g)) {
    system = 'Ios' // ios系统
  }

  // 系统版本
  let systemVs: string | null | undefined | false = 'unknow'
  if (system === 'windows') {
    if (testUa(/windows nt 5.0|windows 2000/g)) {
      systemVs = '2000'
    } else if (testUa(/windows nt 5.1|windows xp/g)) {
      systemVs = 'xp'
    } else if (testUa(/windows nt 5.2|windows 2003/g)) {
      systemVs = '2003'
    } else if (testUa(/windows nt 6.0|windows vista/g)) {
      systemVs = 'vista'
    } else if (testUa(/windows nt 6.1|windows 7/g)) {
      systemVs = '7'
    } else if (testUa(/windows nt 6.2|windows 8/g)) {
      systemVs = '8'
    } else if (testUa(/windows nt 6.3|windows 8.1/g)) {
      systemVs = '8.1'
    } else if (testUa(/windows nt 10.0|windows 10/g)) {
      systemVs = '10'
    } else if (testUa(/windows nt 11.0|windows 11/g)) {
      systemVs = '10'
    }
  } else if (system === 'macos') {
    systemVs = testVs(/os x [\d._]+/g)
  } else if (system === 'android') {
    systemVs = testVs(/android [\d._]+/g)
  } else if (system === 'ios') {
    systemVs = testVs(/os [\d._]+/g)
  }

  // 浏览器
  let browser = 'unknow'
  let browserVs: string | null | undefined | false = 'unknow'
  if (testUa(/applewebkit/g)) {
    if (testUa(/edg/g)) {
      browser = 'Edge' // edge浏览器
      browserVs = testVs(/edg\/[\d._]+/g)
    } else if (testUa(/opr/g)) {
      browser = 'Opera' // opera浏览器
      browserVs = testVs(/opr\/[\d._]+/g)
    } else if (testUa(/chrome/g)) {
      browser = 'Chrome' // chrome浏览器
      browserVs = testVs(/chrome\/[\d._]+/g)
    } else if (testUa(/safari/g)) {
      browser = 'Safari' // safari浏览器
      browserVs = testVs(/version\/[\d._]+/g)
    }
  } else if (testUa(/gecko/g) && testUa(/firefox/g)) {
    browser = 'Firefox' // firefox浏览器
    browserVs = testVs(/firefox\/[\d._]+/g)
  } else if (testUa(/presto/g)) {
    browser = 'Opera' // opera浏览器
    browserVs = testVs(/opr\/[\d._]+/g)
  } else if (testUa(/trident|compatible|msie/g)) {
    browser = 'Iexplore' // iexplore浏览器
    browserVs = testVs(/(msie [\d._]+)|(rv:[\d._]+)/g)
  } else if (testUa(/micromessenger/g)) {
    browser = 'Wechat' // 微信浏览器
    browserVs = testVs(/micromessenger\/[\d._]+/g)
  } else if (testUa(/qqbrowser/g)) {
    browser = 'QQ' // QQ浏览器
    browserVs = testVs(/qqbrowser\/[\d._]+/g)
  } else if (testUa(/ucbrowser/g)) {
    browser = 'Uc' // UC浏览器
    browserVs = testVs(/ucbrowser\/[\d._]+/g)
  } else if (testUa(/qihu 360se/g)) {
    browser = '360' // 360浏览器(无版本)
  } else if (testUa(/2345explorer/g)) {
    browser = '2345' // 2345浏览器
    browserVs = testVs(/2345explorer\/[\d._]+/g)
  } else if (testUa(/metasr/g)) {
    browser = 'Sougou' // 搜狗浏览器(无版本)
  } else if (testUa(/lbbrowser/g)) {
    browser = 'Liebao' // 猎豹浏览器(无版本)
  } else if (testUa(/maxthon/g)) {
    browser = 'Maxthon' // 遨游浏览器
    browserVs = testVs(/maxthon\/[\d._]+/g)
  }

  return {
    browser,
    browserVs,
    system,
    systemVs,
  }
}

export default getBrowserInfo
